module.exports = __webpack_public_path__ + "static/media/moon.55d1e942.svg";